var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(0.5)",
    fill: "white",
    fillOpacity: 0.01,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 22.5C17.61 22.5 16.74 22.2361 15.9999 21.7416C15.2599 21.2472 14.6831 20.5444 14.3425 19.7221C14.0019 18.8998 13.9128 17.995 14.0865 17.1221C14.2601 16.2492 14.6887 15.4474 15.318 14.818C15.9474 14.1887 16.7492 13.7601 17.6221 13.5865C18.495 13.4128 19.3998 13.502 20.2221 13.8426C21.0443 14.1831 21.7471 14.7599 22.2416 15.4999C22.7361 16.24 23 17.11 23 18C22.9987 19.1931 22.5241 20.3369 21.6805 21.1805C20.8369 22.0241 19.6931 22.4987 18.5 22.5ZM18.5 15C17.9067 15 17.3266 15.176 16.8333 15.5056C16.3399 15.8352 15.9554 16.3038 15.7284 16.852C15.5013 17.4001 15.4419 18.0033 15.5576 18.5853C15.6734 19.1672 15.9591 19.7018 16.3787 20.1213C16.7982 20.5409 17.3328 20.8266 17.9147 20.9424C18.4967 21.0581 19.0999 20.9987 19.6481 20.7717C20.1962 20.5446 20.6648 20.1601 20.9944 19.6667C21.3241 19.1734 21.5 18.5934 21.5 18C21.4991 17.2046 21.1827 16.4421 20.6203 15.8797C20.0579 15.3173 19.2954 15.0009 18.5 15Z",
    fill: "#0092C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 16.5H6.5V18H12.5V16.5Z",
    fill: "#0092C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12H6.5V13.5H14V12Z",
    fill: "#0092C6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 21H5V3.00001H11V7.50001C11.0011 7.89749 11.1596 8.27835 11.4406 8.55941C11.7217 8.84046 12.1025 8.99887 12.5 9.00001H17V11.25H18.5V7.50001C18.5027 7.40144 18.484 7.30346 18.4451 7.21282C18.4063 7.12218 18.3482 7.04105 18.275 6.97501L13.025 1.72501C12.959 1.65176 12.8778 1.59371 12.7872 1.55486C12.6966 1.51601 12.5986 1.4973 12.5 1.50001H5C4.60253 1.50116 4.22166 1.65957 3.94061 1.94062C3.65955 2.22168 3.50115 2.60254 3.5 3.00001V21C3.50115 21.3975 3.65955 21.7783 3.94061 22.0594C4.22166 22.3405 4.60253 22.4989 5 22.5H12.5V21ZM12.5 3.30001L16.7 7.50001H12.5V3.30001Z",
    fill: "#0092C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocHome);
export default __webpack_public_path__ + "static/media/docHome.280da156a81b6c92cc0533ed2080f919.svg";
export { ForwardRef as ReactComponent };